import { motion } from "framer-motion";
import { PageHero } from "../components/site/PageHero";
import { SectionHeading } from "../components/site/SectionHeading";
import { Reveal } from "../components/site/Reveal";
import { CtaBand } from "../components/site/CtaBand";
import { STEPS_CANDIDATE, STEPS_EMPLOYER } from "../content/site";
import { useSeo } from "../lib/useSeo";

const Timeline = ({ title, steps, testid }) => (
  <div data-testid={testid}>
    <h2 className="text-2xl md:text-3xl font-bold text-[color:var(--navy)]">{title}</h2>
    <ol className="relative mt-10 space-y-8 pl-10">
      <motion.span
        aria-hidden="true" initial={{ scaleY: 0 }} whileInView={{ scaleY: 1 }} viewport={{ once: true, amount: 0.1 }} transition={{ duration: 1.6, ease: "easeOut" }}
        className="absolute left-[15px] top-2 bottom-2 w-px origin-top bg-[color:var(--teal)]"
      />
      {steps.map((s, i) => (
        <Reveal as="li" key={s.t} delay={i * 0.04} className="relative">
          <span className="absolute -left-10 top-0 grid h-8 w-8 place-items-center rounded-full bg-[color:var(--navy)] text-xs font-bold text-white">{i + 1}</span>
          <h3 className="text-lg font-bold text-[color:var(--navy)]">{s.t}</h3>
          <p className="mt-1.5 leading-relaxed text-slate-600">{s.d}</p>
        </Reveal>
      ))}
    </ol>
  </div>
);

export default function Process() {
  useSeo("Ablauf", "So läuft die internationale Direktvermittlung mit PACTORA ab – Schritt für Schritt für Arbeitgeber und für Bewerber.", "/ablauf");
  return (
    <>
      <PageHero testid="process-hero" eyebrow="Ablauf" lines={["Schritt für Schritt.", "Für beide Seiten klar."]}
        intro="Hier sehen Sie, wie eine Vermittlung typischerweise abläuft. Der konkrete Ablauf kann je nach Beruf, Herkunftsland und Einzelfall abweichen – etwa wenn eine Berufsanerkennung oder zusätzliche Sprachnachweise nötig sind." />
      <section className="bg-white pb-24 md:pb-32">
        <div className="container-x grid gap-16 lg:grid-cols-2 lg:gap-20">
          <Timeline title="Für Arbeitgeber" steps={STEPS_EMPLOYER} testid="timeline-employer" />
          <Timeline title="Für Bewerber" steps={STEPS_CANDIDATE} testid="timeline-candidate" />
        </div>
      </section>
      <section className="bg-[color:var(--mist)] py-20 md:py-28">
        <div className="container-x">
          <SectionHeading eyebrow="Wichtig zu wissen" title="Behörden entscheiden – wir koordinieren." intro="Über Visa, Aufenthaltstitel, die Zustimmung der Bundesagentur für Arbeit und Berufsanerkennungen entscheiden ausschließlich die zuständigen Stellen. Feste Bearbeitungszeiten oder bestimmte Ergebnisse können wir daher nicht zusagen. Wir begleiten die organisatorische Abstimmung und halten alle Beteiligten auf dem Laufenden." />
        </div>
      </section>
      <CtaBand />
    </>
  );
}
